export const EXPENSE_CATEGORIES = [
  'Rent',
  'Utilities',
  'Supplies',
  'Marketing',
  'Insurance',
  'Software',
  'Maintenance',
  'ProfessionalServices',
  'Taxes',
  'Inventory',
  'Other',
];

export const EXPENSE_FREQUENCIES = ['Weekly', 'Monthly', 'Yearly'];

export const EXPENSE_END_MODES = ['Never', 'AfterCount', 'OnDate'];

export const EXPENSE_EDIT_SCOPES = ['OnlyThis', 'ThisAndFuture', 'All'];

export const EXPENSE_SOURCE_TYPES = ['Manual', 'StockPurchase', 'Recurring'];

export const RECURRENCE_LIMITS = {
  maxOccurrences: 520,
  maxYears: 10,
};

export default EXPENSE_CATEGORIES;
